import CheckboxComponent from './CheckboxComponent'

export default CheckboxComponent
